import { useCallback, useMemo } from 'react';
import { toNumber } from 'lodash';

import { NON_ASSIGNABLE_VALUE } from '@/common/constants';
import useReimbursementStore from '@/modules/employer/components/SetupEmployer/Features/Reimbursement/stores/useReimbursement.store';

const useAdminFeesValidation = () => {
  const { paymentEmployeeFees } = useReimbursementStore();
  const hasEmployeePaidFeeAmount = useMemo(() => Object.values(paymentEmployeeFees)
    .some((item) => toNumber(item)), [paymentEmployeeFees]);
  const isValidThroughEmployeeFee = useCallback((administratorFeesBank?: string) => !hasEmployeePaidFeeAmount
    || Boolean(administratorFeesBank && administratorFeesBank !== NON_ASSIGNABLE_VALUE),
  [hasEmployeePaidFeeAmount]);

  return {
    isValidThroughEmployeeFee,
  };
};

export default useAdminFeesValidation;
